import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Suspense as _Suspense, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { DateTime } from 'ts-luxon'
import { provide, ref } from 'vue'
import VueGtag from 'vue-gtag'

import { useStore } from '@/store'
import { notifications } from '@/plugins/notifications'
import { ModalWrapper } from '@/composables/general'
import Logo from '@/components/global/Logo.vue'
import Menu from '@/components/global/Menu.vue'
import { app } from '@/main'
import router from '@/router'


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const store = useStore()
store.modalOpened = 0

const i = ref(0)

notifications()

if (store.platform === 'web' && process.env.NODE_ENV === 'production') {
  app.use(
    VueGtag,
    {
      appName: 'HALP web',
      pageTrackerScreenviewEnabled: true,
      config: {
        id: 'G-5F6GWDJ71J',
      },
    },
    router
  )
}

const appEl = ref<HTMLElement>()
provide(ModalWrapper, appEl)

window.setInterval(() => {
  store.now = DateTime.now()
}, 10 * 1000)

return (_ctx: any,_cache: any) => {
  const _component_metainfo = _resolveComponent("metainfo")!
  const _component_ion_router_outlet = _resolveComponent("ion-router-outlet")!
  const _component_ion_app = _resolveComponent("ion-app")!

  return (_openBlock(), _createBlock(_Suspense, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_app, {
        id: "test",
        ref_key: "appEl",
        ref: appEl,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (i.value++))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_metainfo, null, {
            title: _withCtx(({ content, metainfo }) => [
              _createTextVNode(_toDisplayString(content ? `${content} |` : '') + " HALP — 21-23. Jún 2024 — festival súčasnej klubovej hudby ", 1)
            ]),
            _: 1
          }),
          _createVNode(Logo, {
            class: "logo",
            rng: 1
          }),
          _createVNode(Menu, { class: "menu" }),
          _createVNode(_component_ion_router_outlet, { id: "main-content" })
        ]),
        _: 1
      }, 512)
    ]),
    _: 1
  }))
}
}

})